(() => {
  const favoriteKey = 'techno-favorites';
  const compare = new Set();

  const readFavorites = () => {
    try { return new Set(JSON.parse(localStorage.getItem(favoriteKey) || '[]')); }
    catch { return new Set(); }
  };

  let favorites = readFavorites();

  const syncFavorites = () => {
    document.querySelectorAll('[data-techno-favorite]').forEach((button) => {
      const active = favorites.has(button.dataset.technoFavorite);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    document.querySelectorAll('[data-techno-favorite-count]').forEach((badge) => {
      badge.textContent = favorites.size;
      badge.hidden = favorites.size === 0;
    });
  };

  const syncCompare = () => {
    document.querySelectorAll('[data-techno-compare]').forEach((button) => {
      const active = compare.has(button.dataset.technoCompare);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    const bar = document.querySelector('[data-techno-compare-bar]');
    if (!bar) return;
    const visible = compare.size > 0;
    if (visible) {
      bar.hidden = false;
      bar.setAttribute('aria-hidden', 'false');
      window.requestAnimationFrame(() => bar.classList.add('is-visible'));
    } else {
      bar.classList.remove('is-visible');
      bar.hidden = true;
      bar.setAttribute('aria-hidden', 'true');
    }
    const count = bar.querySelector('[data-techno-compare-count]');
    if (count) count.textContent = compare.size;
  };

  let previewReturnFocus = null;

  const setPreviewState = (modal, state) => {
    const stage = modal?.querySelector('[data-techno-preview-stage]');
    const toggle = modal?.querySelector('[data-preview-pair-toggle]');
    if (!stage) return;
    stage.dataset.state = state;
    const isOn = state === 'on';
    if (toggle) {
      toggle.setAttribute('aria-pressed', String(isOn));
      toggle.setAttribute('aria-label', isOn ? 'Preview lights off' : 'Preview lights on');
    }
  };

  const closePreview = () => {
    const modal = document.querySelector('[data-techno-quick-preview-modal]');
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    previewReturnFocus?.focus?.();
  };

  const openPreview = (button) => {
    const modal = document.querySelector('[data-techno-quick-preview-modal]');
    if (!modal) return;
    previewReturnFocus = button;
    const offImage = modal.querySelector('[data-preview-image-off]');
    const onImage = modal.querySelector('[data-preview-image-on]');
    const title = modal.querySelector('[data-preview-title]');
    const type = modal.querySelector('[data-preview-type]');
    const model = modal.querySelector('[data-preview-model]');
    const specs = modal.querySelector('[data-preview-specs]');
    const price = modal.querySelector('[data-preview-price]');
    const link = modal.querySelector('[data-preview-link]');
    const add = modal.querySelector('[data-preview-add]');
    const status = modal.querySelector('[data-preview-status]');
    const offUrl = button.dataset.imageOff || button.dataset.image || '';
    const onUrl = button.dataset.imageOn || '';
    if (offImage) {
      offImage.src = offUrl;
      offImage.alt = `${button.dataset.title || ''}, lights off`;
      offImage.hidden = !offUrl;
    }
    if (onImage) {
      onImage.src = onUrl;
      onImage.alt = `${button.dataset.title || ''}, illuminated`;
      onImage.hidden = !onUrl;
    }
    modal.classList.toggle('techno-quick-preview--has-pair', Boolean(onUrl));
    if (title) title.textContent = button.dataset.title || '';
    if (type) type.textContent = button.dataset.type || '';
    if (model) model.textContent = button.dataset.model || '';
    if (specs) specs.textContent = button.dataset.specs || 'Verified technical specifications will appear here.';
    if (price) price.textContent = button.dataset.price || '';
    if (link) link.href = button.dataset.url || '#';
    if (add) {
      add.dataset.variantId = button.dataset.variantId || '';
      add.disabled = button.dataset.available !== 'true' || !button.dataset.variantId;
      add.textContent = add.disabled ? 'View product options' : 'Add to cart';
    }
    if (status) status.textContent = '';
    const mode = document.documentElement.dataset.colorMode || 'light';
    setPreviewState(modal, onUrl && mode === 'dark' ? 'on' : 'off');
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    modal.querySelector('[data-techno-preview-close]')?.focus();
  };


  document.addEventListener('click', (event) => {
    const favorite = event.target.closest('[data-techno-favorite]');
    if (favorite) {
      const id = favorite.dataset.technoFavorite;
      favorites.has(id) ? favorites.delete(id) : favorites.add(id);
      localStorage.setItem(favoriteKey, JSON.stringify([...favorites]));
      syncFavorites();
      return;
    }

    const compareButton = event.target.closest('[data-techno-compare]');
    if (compareButton) {
      const id = compareButton.dataset.technoCompare;
      if (!compare.has(id) && compare.size >= 4) return;
      compare.has(id) ? compare.delete(id) : compare.add(id);
      syncCompare();
      return;
    }

    const preview = event.target.closest('[data-techno-preview]');
    if (preview) { event.preventDefault(); event.stopPropagation(); openPreview(preview); return; }
    const previewToggle = event.target.closest('[data-preview-pair-toggle]');
    if (previewToggle) {
      const modal = previewToggle.closest('[data-techno-quick-preview-modal]');
      const stage = modal?.querySelector('[data-techno-preview-stage]');
      if (stage) setPreviewState(modal, stage.dataset.state === 'on' ? 'off' : 'on');
      return;
    }
    const previewAdd = event.target.closest('[data-preview-add]');
    if (previewAdd && !previewAdd.disabled) {
      const status = previewAdd.closest('[data-techno-quick-preview-modal]')?.querySelector('[data-preview-status]');
      previewAdd.disabled = true;
      fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(previewAdd.dataset.variantId), quantity: 1 }] }) })
        .then((response) => { if (!response.ok) throw new Error('Unable to add product'); return response.json(); })
        .then(() => { if (status) status.textContent = 'Added to cart.'; document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); })
        .catch(() => { if (status) status.textContent = 'Open the product page to choose options.'; })
        .finally(() => { previewAdd.disabled = false; });
      return;
    }
    if (event.target.closest('[data-techno-preview-close], [data-techno-preview-backdrop]')) closePreview();
    if (event.target.closest('[data-techno-compare-clear]')) { compare.clear(); syncCompare(); }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closePreview();
  });

  const initialize = () => { syncFavorites(); syncCompare(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
